import React from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { motion } from "framer-motion";
import { ballMotion } from "../../../animations/framer";
import { FormattedMessage } from "react-intl";

const style = {
	solWrapper: `mb-12 lg:mb-0 relative py-4 lg:basis-1/2`,
	titleWrapper: `mb-8 z-10`,
	title: `text-2xl tracking-wide text-center text-red lg:text-4xl uppercase aubrey-pro font-bold`,
	solItems: ` relative flex flex-col gap-4`,
	pyramid: `mt-8`,
	pyramidMain: `relative flex flex-col items-center justify-center mt-4`,
	solItem: `flex items-start gap-2 z-10`,
	itemText: `leading-5 lg:text-lg`,
	tick: `text-[#12C800] mr-8`,
	excl: `text-red mr-8`,
	triangle: `w-full max-w-[500px] select-none pointer-events-none`,
	neonLimeMini: `absolute top-[10%] left-[30%] shadow-[0px_0px_50px_30px_#DAF66A]`,
	neonLimeTwo: `absolute top-[50%] left-[60%] shadow-[0px_0px_50px_30px_#DAF66A]`,
	neonBlueMini: `absolute top-[60%] left-[40%] shadow-[0px_0px_50px_30px_#4430D0]`,
	neonBlueTwo: `absolute top-[10%] left-[20%] shadow-[0px_0px_50px_30px_#4430D0]`,
	neonRed: `absolute top-[40%] left-[20%] shadow-[0px_0px_50px_30px_#FB7151]`,
	neonRedTwo: `absolute top-[10%] left-[70%] shadow-[0px_0px_50px_30px_#FB7151]`,
};

const Solutions = () => {
	return (
		<div className={style.solWrapper}>
			<div className={style.titleWrapper}>
				<h2 className={style.title}>
					<FormattedMessage id='courseRoadTitle' />
				</h2>
			</div>
			<div className={style.solItems}>
				<motion.div
					variants={ballMotion}
					animate='startone'
					className={style.neonLimeMini}
				></motion.div>
				<motion.div
					variants={ballMotion}
					animate='starttwo'
					className={style.neonLimeTwo}
				></motion.div>
				<motion.div
					variants={ballMotion}
					animate='startthree'
					className={style.neonBlueMini}
				></motion.div>
				<motion.div
					variants={ballMotion}
					animate='startfour'
					className={style.neonBlueTwo}
				></motion.div>
				<motion.div
					variants={ballMotion}
					animate='startfive'
					className={style.neonRed}
				></motion.div>
				<motion.div
					variants={ballMotion}
					animate='startsix'
					className={style.neonRedTwo}
				></motion.div>
				<div className={style.solItem}>
					<ErrorOutlineIcon className={style.excl} />
					<p className={style.itemText}>
						<FormattedMessage id='courseRoadOne' />
					</p>
				</div>
				<div className={style.solItem}>
					<ErrorOutlineIcon className={style.excl} />
					<p className={style.itemText}>
						<FormattedMessage id='courseRoadTwo' />
					</p>
				</div>
				<div className={style.solItem}>
					<ErrorOutlineIcon className={style.excl} />
					<p className={style.itemText}>
						<FormattedMessage id='courseRoadThree' />
					</p>
				</div>
				<div className={style.solItem}>
					<ErrorOutlineIcon className={style.excl} />
					<p className={style.itemText}>
						<FormattedMessage id='courseRoadFour' />
					</p>
				</div>
				<div className={style.solItem}>
					<CheckCircleOutlineIcon className={style.tick} />
					<p className={style.itemText}>
						<FormattedMessage id='courseRoadFive' />
					</p>
				</div>
			</div>
		</div>
	);
};

export default Solutions;
